import styled from '@emotion/styled';
import {ICookieBannerProps} from './CookieBannerComponent';

type WrapperProps = Partial<ICookieBannerProps>;

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
